import { EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { MemberPreferenceType } from '../../../common/enums/member-preference.enum';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { CacheService } from '../../../shared/services/cache.service';
import { IsoCodeThree } from '../../common/constants';
import { OrderType } from '../../common/enumerations';
import { ResponseStatus } from '../../constants/response-status-constants';
import { MemeberCommunicationPreferenceValue } from '../../enums/member-communication-preference-value.enum';
import { SponsorSearchCriteria } from '../../enums/sponsor-search-criteria.enum';
import { SponsorSearchOption } from '../../enums/sponsor-search-option.enum';
import { SponsorWizardSearchType } from '../../enums/sponsor-wizard-type.enum';
import { CustomerService } from '../../services/customer.service';
import { EnrollmentMessageService } from '../../services/enrollment-message.service';
import { SponsorConfigService } from '../../services/sponsor-config.service';
import { SponsorService } from '../../services/sponsor.service';
var SponsorSearchComponent = /** @class */ (function () {
    function SponsorSearchComponent(_sponsorService, _formBuilder, _cacheService, _enrollmentMessageService, _customerService, _sponsorConfigService) {
        this._sponsorService = _sponsorService;
        this._formBuilder = _formBuilder;
        this._cacheService = _cacheService;
        this._enrollmentMessageService = _enrollmentMessageService;
        this._customerService = _customerService;
        this._sponsorConfigService = _sponsorConfigService;
        // tslint:disable-next-line:no-output-rename
        this.selectedSponsorInfo = new EventEmitter();
        // tslint:disable-next-line:no-output-rename
        this.rebindSponsor = new EventEmitter();
        this.isRepSiteSponsor = false;
        this.isSponsorLoading = false;
        this.sponsorSearchWizardType = SponsorWizardSearchType;
        this.sponsorSearchOptionType = SponsorSearchOption;
        this.zipPattern = '^[0-9]{5}(-[0-9]{4})?$';
        this.isSponsorSelected = true;
        this.showAuthorizedFBO = true;
        this.searchBySponsorError = false;
        this.sponsorNotFound = false;
        this.noSponsorFound = false;
        this.isFboNameEnabled = false;
        this.isFboIdEnabled = false;
        this.isSponsorEligible = true;
        this.noSuggestSponsorFound = false;
        this.suggestSponsorFound = false;
        this.isAutoAssign = false;
        this.formSubmitted = false;
        this.cityOrZipcodeerrMsg = false;
        this.isReferrerEligible = true;
        this.referrerSponsorNotFound = false;
        this.memberCommunicationPreferences = {
            email: false,
            phone: false
        };
        this.showStates = true;
        this.notifyMeCheckBoxControl = new FormControl('');
        this.isLoggedInSponsorInfo = false;
        this.sponsorSearchCriteria = SponsorSearchCriteria;
        this.sponsorPollCount = 0;
        this.isoCountryCode = '';
        this.languageCode = '';
        this.sponsorMaxPollCount = environment.longPollCount;
        this.pollStarted = false;
        this.searchOptionChanged = false;
        this.isSponsorOptional = false;
        this.orderType = OrderType;
        this.sponsorInfoNotSelectedErr = false;
        this.defaultStateId = 0;
        this.cityFieldRequired = false;
        this.participatingCountrySelected();
    }
    SponsorSearchComponent.prototype.ngOnInit = function () {
        var isLoadSponsorOptions = false;
        if (this.storeInfo) {
            if (this.selectedCountryISO !== this.storeInfo.homeIsocodeThree) {
                isLoadSponsorOptions = true;
            }
            this.selectedCountryISO = this.storeInfo.homeIsocodeThree;
        }
        else {
            this.selectedCountryISO = 'USA';
        }
        this.sponsorConfig = this._sponsorConfigService.getSettings(this.selectedCountryISO);
        this.getStoreConfig();
        if (isLoadSponsorOptions) {
            this.getSponsorSearchOptions();
        }
        this.isSponsorOptional = this.sponsorConfig && this.sponsorConfig.loadSponsorWizardInGuestFlow;
        this.isSponsorInfoSelected();
    };
    SponsorSearchComponent.prototype.getStoreConfig = function () {
        var _this = this;
        this.getCountriesLookup();
        this.storeSubscription = this._enrollmentMessageService.getStoreInfo().subscribe(function (response) {
            if (response) {
                _this.storeInfo = response;
                _this.selectedCountryISO = _this.storeInfo.homeIsocodeThree;
                _this.sponsorConfig = _this._sponsorConfigService.getSettings(_this.selectedCountryISO);
                _this.selectedSponsorCountry = _this.storeInfo.countryId ? _this.storeInfo.countryId : _this.browserCountry.countryId;
                _this.countryId = _this.storeInfo.countryId;
                _this.getCountriesLookup();
                _this.getSponsorSearchOptions();
            }
            else {
                _this.resetVariable(SponsorWizardSearchType.SearchByIDontHaveSponsor);
            }
        });
        // this.validateParticipatingCountry();
    };
    SponsorSearchComponent.prototype.validateParticipatingCountry = function () {
        if (this.participatingCountry) {
            this.selectedSponsorCountry = this.participatingCountry.countryId;
            this.onCountryChange(this.selectedSponsorCountry);
        }
        else {
            this.selectedSponsorCountry = this.storeInfo && this.storeInfo.countryId ? this.storeInfo.countryId
                : this.browserCountry.countryId;
        }
        this.countryId = this.selectedSponsorCountry;
    };
    /**
  * @description this method will load config info based on country
  * @private
  * @memberof SponsorSelectionComponentNew
  */
    SponsorSearchComponent.prototype.loadSponsorConfigInfo = function (storeInfo) {
        var _this = this;
        if (storeInfo) {
            this.getLanguagesLookup(storeInfo);
        }
        else {
            this._sponsorService.getStoreByCountryCode(this.selectedCountryISO).subscribe(function (res) {
                if (res) {
                    _this.getLanguagesLookup(res);
                }
            });
        }
        this.getZipCodePatterns();
        this.setSuggestSponsorPreference();
    };
    /**
    * @description this method
    * is used to set default country and zipCode
    * based on mailing address
    * @date 2018-07-20
    * @memberof SponserSelectionComponent
    */
    SponsorSearchComponent.prototype.setSuggestSponsorPreference = function () {
        var _this = this;
        this._enrollmentMessageService.getSponsorPreference()
            .subscribe(function (liveFormAddress) {
            if (liveFormAddress) {
                _this.selectedZipCode = liveFormAddress.zip;
                _this.selectedCity = liveFormAddress.city;
                _this.city = _this.selectedCity;
                _this.setSuggestZipCode = _this.selectedZipCode;
                _this.addressLine1 = liveFormAddress.addressLine1;
                _this.selectedState = liveFormAddress.stateId;
                _this.setSuggestState = _this.selectedState;
                _this.addressId = liveFormAddress.addressId ? liveFormAddress.addressId : _this.addressId;
                _this.buildSuggestSponsorForm();
            }
        });
    };
    /**
    * suggestSponsor method used to prepare request for Suggest a Sponsor
    * @param  form
    * @param  {boolean} isValid
    * @returns void
    */
    SponsorSearchComponent.prototype.suggestSponsor = function (form, isValid) {
        var _this = this;
        var languageId;
        if (!form.value.sponsorZipcode &&
            (this.sponsorConfig && !this.sponsorConfig.isSponsorSearchByArea)) {
            this.cityOrZipcodeerrMsg = true;
            return;
        }
        if (!form.value.sponsorCity &&
            (this.sponsorConfig && this.sponsorConfig.sponsorCityFieldRequired)) {
            this.cityFieldRequired = true;
            return;
        }
        else {
            this.cityFieldRequired = false;
        }
        if (this.sponsorConfig && this.sponsorConfig.isSponsorSearchByArea && !form.value.sponsorState) {
            this.cityOrZipcodeerrMsg = true;
            return;
        }
        if (form.value.sponsorLanguage && this.setLanguagesByCountry) {
            languageId = this.setLanguagesByCountry.find(function (x) { return x.languageName.toUpperCase()
                === form.value.sponsorLanguage.toUpperCase(); }).languageId;
        }
        var addressLine1 = '';
        if (this.addressLine1
            && this.setSuggestZipCode && form.value.sponsorZipcode
            && (this.setSuggestZipCode === form.value.sponsorZipcode)) {
            addressLine1 = this.addressLine1;
        }
        var suggestedAddressId = null;
        if (this.sponsorConfig && this.sponsorConfig.addressIdForSponsorSearch) {
            if (this.setSuggestZipCode && form.value.sponsorZipcode && this.setSuggestZipCode === form.value.sponsorZipcode) {
                suggestedAddressId = this.addressId ? this.addressId : 0;
            }
            else if (this.setSuggestZipCode && form.value.sponsorZipcode && this.setSuggestZipCode != form.value.sponsorZipcode) {
                suggestedAddressId = 0;
            }
        }
        var country = this.countries.find(function (x) {
            return (x.countryId) === +_this.countryId;
        });
        var sponsorSearchRequest = {
            UserName: '',
            Email: '',
            FirstName: '',
            LastName: '',
            CountryId: this.countryId ? this.countryId.toString() : '',
            CountryCode: country ? country.isocodeThree : this.selectedCountryISO,
            AddressLine1: addressLine1,
            PreferenceValue: languageId,
            addressId: suggestedAddressId,
            PostalCode: form.value.sponsorZipcode ? form.value.sponsorZipcode : '',
            StateId: this.suggestSponsorForm.controls['sponsorState'].value ?
                this.suggestSponsorForm.controls['sponsorState'].value.toString() : '',
            City: form.value.sponsorCity ? form.value.sponsorCity : '',
            Option: this.sponsorConfig && this.sponsorConfig.isSponsorSearchByArea ?
                SponsorSearchOption.SearchByArea : SponsorSearchOption.SearchByIDontHaveSponsor,
            EnableLongPoll: environment.enableLongPoll,
            Store: country ? country.isocodeThree : this.selectedCountryISO
        };
        if (!this.sponsorConfig.participatingCountryForSponsorSerach) {
            sponsorSearchRequest.ParticipatingCountryCode = '';
        }
        if (!this.formSubmitted) {
            this.formSubmitted = true;
            this.markControlsAsTouched(this.suggestSponsorForm);
        }
        if (isValid || !form.value.sponsorZipcode) {
            this.getSponsorInformation(sponsorSearchRequest, SponsorSearchOption.SearchByIDontHaveSponsor);
        }
    };
    /**
     * Mark all the elements as touched to show validation messages
     * @param  {FormGroup} form
     * @returns void
     */
    SponsorSearchComponent.prototype.markControlsAsTouched = function (form) {
        if (form) {
            Object.keys(form.controls).forEach(function (key) {
                form.controls[key].markAsTouched();
            });
        }
    };
    /**
       * Getting Languages by Country
       * getLanguagesLookup
       * @param {string} selectedCountryISO
       * @memberof SponsorSelectionComponentNew
       */
    SponsorSearchComponent.prototype.getLanguagesLookup = function (storeInfo) {
        var _this = this;
        this.setLanguagesByCountry = storeInfo.languages;
        if (this.storeInfo && this.storeInfo.languages) {
            this.languageCode = this.storeInfo.languages.find(function (x) { return x.default === true; }).cultureName;
        }
        this.setSuggestLanguage = this.setLanguagesByCountry.find(function (x) { return x.cultureName.toUpperCase()
            === _this.languageCode.toUpperCase(); }).languageName;
        this.buildSuggestSponsorForm();
    };
    /**
       *  Get zipcode patterns
       *  getZipCodePatterns
       * @memberof SponsorSelectionComponentNew
       */
    SponsorSearchComponent.prototype.getZipCodePatterns = function () {
        var _this = this;
        this._sponsorService.getZipCodePatterns().subscribe(function (response) {
            var country = _this.countries.find(function (x) {
                return (x.countryId) === +_this.countryId;
            });
            var countryCode = country && _this.participatingCountry ? country.isocodeThree : _this.selectedCountryISO;
            _this.zipCodePatterns = response;
            var pattern = _this.zipCodePatterns.filter(function (x) { return x.isoCodeThree
                === countryCode; })[0];
            _this.zipPattern = pattern ? pattern.zipPattern : null;
        });
    };
    /**
     * @description method to get sponsor search options
     * @memberof SponsorSelectionComponentNew
     */
    SponsorSearchComponent.prototype.getSponsorSearchOptions = function () {
        var _this = this;
        var operatingCountry = this.storeInfo && this.storeInfo.operatingCountry || IsoCodeThree.USA;
        this._sponsorService
            .sponsorOptions(operatingCountry)
            .subscribe(function (response) {
            if (response) {
                _this.sponsorSearchOptions = response.sponsorSearchOptions;
                var sponsorId = '';
                if (_this.sponsorConfig && _this.sponsorConfig.loadSponsorWizardInGuestFlow
                    && (_this.selectedOrderType === OrderType.NEW_GUEST_RETAIL || _this.selectedOrderType === OrderType.NEW_FPC)) {
                    if (_this.sponsorConfig.displayIDontHaveSponsorGuestSection && _this.selectedOrderType === OrderType.NEW_GUEST_RETAIL) {
                        _this.sponsorWizard = SponsorWizardSearchType.SearchByIDontHaveSponsor;
                    }
                    else {
                        _this.sponsorWizard = SponsorWizardSearchType.SearchByIKnowSponsor;
                    }
                }
                else {
                    _this.sponsorWizard = SponsorWizardSearchType.SearchByIKnowSponsor;
                }
                var rebindSponsorData = _this.rebindSponsorOptions;
                if (_this.selectedSponsor) {
                    sponsorId = _this.selectedSponsor.sponsorId ?
                        _this.selectedSponsor.sponsorId : '';
                }
                if (sponsorId && rebindSponsorData && !rebindSponsorData.isDefaultSponsorSelected && rebindSponsorData.sponsorWizardType) {
                    _this.rebindSponsorData(rebindSponsorData);
                }
                else if (_this.userInfo && _this.userInfo.sponsorId) {
                    _this.getMemberCommunication();
                }
                else {
                    _this.setSponsorWizard(_this.sponsorWizard);
                }
            }
        });
    };
    /**
    * addig sponsor search for guest
    */
    SponsorSearchComponent.prototype.prepareDontHaveSponsorGuestSection = function () {
        var sponsorSearchOptions = {
            id: SponsorSearchOption.DonthaveSponsorGuest,
            option: SponsorWizardSearchType.DonthaveSponsorGuest,
            autoAssign: false,
            sponsorSearchValues: [],
        };
        return sponsorSearchOptions;
    };
    /**
    * preload suggest sponsor information
    * @memberof SponsorSelectionComponentNew
    */
    SponsorSearchComponent.prototype.preloadSponsorInformation = function (rebindSponsorData, sponsorInfo) {
        this.selectedSponsor = sponsorInfo;
        var sponsors = [];
        sponsors.push(this.selectedSponsor);
        if (rebindSponsorData.sponsorWizardType === SponsorWizardSearchType.SearchByIDontHaveSponsor) {
            this.searchBySuggestSponsors = sponsors;
            this.suggestSponsorFound = true;
        }
        this.setSponsor(this.selectedSponsor);
        this.setSponsorInformation();
    };
    /**
       *get member preferences and bind with Preferences Data
       *
       * @memberof CommunicationPreferencesComponent
       */
    SponsorSearchComponent.prototype.getMemberCommunication = function () {
        var _this = this;
        var memberCommunicationPreferences = {
            email: false,
            phone: false
        };
        this._sponsorService.getMemberCommunicationPreferences(this.userInfo.memberId).subscribe(function (response) {
            if (response) {
                if (response.memberPreferenceModels) {
                    var email = response.memberPreferenceModels.
                        find(function (item) { return item.preferenceId === MemberPreferenceType.Email &&
                        +item.preferenceValue === MemeberCommunicationPreferenceValue.YES; });
                    var phone = response.memberPreferenceModels.
                        find(function (item) { return item.preferenceId === MemberPreferenceType.Phone &&
                        +item.preferenceValue === MemeberCommunicationPreferenceValue.YES; });
                    var notifyPreferences = response.memberPreferenceModels.
                        find(function (item) { return item.preferenceId === MemberPreferenceType.NotifyMe &&
                        +item.preferenceValue === MemeberCommunicationPreferenceValue.YES; });
                    if (email) {
                        memberCommunicationPreferences.email = true;
                    }
                    if (phone) {
                        memberCommunicationPreferences.phone = true;
                    }
                    _this.rebindMemberPreferences(memberCommunicationPreferences);
                    if (notifyPreferences) {
                        _this.notifyMeCheckBoxControl.setValue(true);
                    }
                }
            }
        });
    };
    /**
  * @description binding member preferences
  * @param {MemberCommunicationPreference} memberCommunicationPreferences
  * @memberof SponsorSelectionComponentNew
  */
    SponsorSearchComponent.prototype.rebindMemberPreferences = function (memberCommunicationPreferences) {
        if (memberCommunicationPreferences.email) {
            this.contactSponsorEmail = memberCommunicationPreferences.email;
            this.isContactSponsorSelected = true;
        }
        if (memberCommunicationPreferences.phone) {
            this.contactSponsorPhone = memberCommunicationPreferences.phone;
            this.isContactSponsorSelected = true;
        }
        this.memberCommunicationPreferences = {
            email: this.contactSponsorEmail,
            phone: false
        };
    };
    /**
     * @description this method will rebind sponsor information
     * @param {RebindSponsorData} rebindSponsorData
     * @memberof SponsorSelectionComponentNew
     */
    SponsorSearchComponent.prototype.rebindSponsorData = function (rebindSponsorData) {
        if (rebindSponsorData.sponsorWizardType) {
            if (rebindSponsorData.sponsorWizardType === SponsorWizardSearchType.SearchByIKnowSponsor) {
                this.resetVariable(SponsorWizardSearchType.SearchByIKnowSponsor);
                this.setSponsorWizard(rebindSponsorData.sponsorWizardType);
                this.firstName = rebindSponsorData.firstName ? rebindSponsorData.firstName : '';
                this.lastName = rebindSponsorData.lastName ? rebindSponsorData.lastName : '';
                this.selectedSponsorCountry = rebindSponsorData.country ? rebindSponsorData.country : 0;
                this.getStatesLookup(this.selectedSponsorCountry, false);
                this.selectedSponsorState = rebindSponsorData.state ? rebindSponsorData.state : 0;
                this.referringFboId = rebindSponsorData.sponsorId ? rebindSponsorData.sponsorId : '';
                if (this.referringFboId) {
                    this.searchSponsorWizardByFboId();
                    this.disableFboIdOrName();
                }
                else {
                    this.searchSponsorByName(this.firstName, this.lastName, this.selectedSponsorCountry, this.selectedSponsorState);
                    this.disableFboIdOrName();
                }
                if (rebindSponsorData.selectedSponsor) {
                    this.selectedSponsor = rebindSponsorData.selectedSponsor;
                    this.preloadSponsorInformation(rebindSponsorData, this.selectedSponsor);
                }
            }
            else if (rebindSponsorData.sponsorWizardType === SponsorWizardSearchType.SearchByIDontHaveSponsor) {
                this.setSponsorWizard(rebindSponsorData.sponsorWizardType);
                this.city = rebindSponsorData.city ? rebindSponsorData.city : '';
                this.setSuggestZipCode = rebindSponsorData.zipCode ? rebindSponsorData.zipCode : '';
                this.setSuggestLanguage = rebindSponsorData.language ? rebindSponsorData.language : '';
                this.setSuggestState = rebindSponsorData.state ? rebindSponsorData.state : 0;
                this.buildSuggestSponsorForm();
                if (this.selectedSponsor) {
                    this.preloadSponsorInformation(rebindSponsorData, this.selectedSponsor);
                }
                else {
                    this.suggestSponsor(this.suggestSponsorForm, true);
                }
            }
        }
    };
    /**
    * setSponsorWizard method used to check or uncheck sponsor search options based on selected value
    * @param  {string} selectedSponsor
    * @returns void
    */
    SponsorSearchComponent.prototype.setSponsorWizard = function (selectedSponsor, removeDefaultSponsor) {
        var _this = this;
        var filteredSponsorOption = [];
        this.isFirstNameError = false;
        this.isLastNameError = false;
        this.sponsorWizard = selectedSponsor;
        if (selectedSponsor === this.sponsorSearchWizardType.SearchByIKnowSponsor) {
            filteredSponsorOption = this.sponsorSearchOptions
                .filter(function (x) { return x.id === _this.sponsorSearchOptionType.SearchByIKnowSponsor; });
            var sponsorFieldByName = this.sponsorSearchOptions
                .filter(function (x) { return x.id === _this.sponsorSearchOptionType.SearchByFBOName; });
            this.sponsorFields = filteredSponsorOption[0].sponsorSearchValues
                .concat(sponsorFieldByName[0].sponsorSearchValues);
        }
        else {
            filteredSponsorOption = this
                .sponsorSearchOptions.filter(function (x) { return x.id
                === _this.sponsorSearchOptionType.SearchByIDontHaveSponsor; });
            if (filteredSponsorOption && filteredSponsorOption.length) {
                this.sponsorFields = filteredSponsorOption[0].sponsorSearchValues;
            }
        }
    };
    /**
       * @description
       * @param {SponsorWizardSearchType} selectedSponsor
       * @memberof SponsorSelectionComponentNew
       */
    SponsorSearchComponent.prototype.resetVariable = function (selectedSponsor) {
        this.noSponsorFound = false;
        this.searchBySuggestSponsors = null;
        this.searchByIDOrNameSponsors = null;
        this.cityOrZipcodeerrMsg = false;
        this.cityFieldRequired = false;
        this.selectedSponsor = null;
        this.sponsorInfoNotSelectedErr = false;
        this.selectedSponsorInfo.emit(this.selectedSponsor);
        this.sponsorWizard = selectedSponsor;
        this.getStatesByCountryId();
        this.selectedSponsorState = 0;
        if (selectedSponsor === this.sponsorSearchWizardType.SearchByIKnowSponsor) {
            this.firstName = '';
            this.lastName = '';
            this.referringFboId = '';
            // this.validateParticipatingCountry();
            // this.selectedSponsorState = 0;
            this.searchBySponsorError = false;
            this.disableFboIdOrName();
        }
        else if (selectedSponsor === this.sponsorSearchWizardType.SearchByIDontHaveSponsor) {
            this.city = this.selectedCity;
            this.setSuggestZipCode = this.selectedZipCode;
            this.buildSuggestSponsorForm();
        }
        this.setSelectedSponsorInformation();
        if (this.pollStarted) {
            this.sponsorPollCount = this.sponsorMaxPollCount;
            this.isSponsorLoading = false;
            this.searchOptionChanged = true;
            this.pollStarted = false;
        }
    };
    /**
  * Suggest Sponsor Form
  * @returns void
  */
    SponsorSearchComponent.prototype.buildSuggestSponsorForm = function () {
        this.suggestSponsorForm = this._formBuilder.group({
            sponsorZipcode: [this.setSuggestZipCode ? this.setSuggestZipCode : '', [Validators.required]],
            sponsorLanguage: [this.setSuggestLanguage ? this.setSuggestLanguage : '', []],
            sponsorState: [this.setSuggestState ? this.setSuggestState : this.defaultStateId, []],
            sponsorCountry: [this.countryId ? this.countryId : '', []],
            sponsorCity: [this.city ? this.city : ''],
        });
        if (this.sponsorConfig && this.sponsorConfig.sponsorCityFieldRequired) {
            this.suggestSponsorForm.controls['sponsorCity'].setValidators([Validators.required]);
            this.suggestSponsorForm.controls['sponsorCity'].updateValueAndValidity();
        }
    };
    Object.defineProperty(SponsorSearchComponent.prototype, "sponsorZipcode", {
        get: function () {
            return this.suggestSponsorForm.get('sponsorZipcode');
        },
        enumerable: true,
        configurable: true
    });
    /**
  * @description this method will enable diable the textbox
  * based on selction
  * @memberof SponsorSelectionComponentNew
  */
    SponsorSearchComponent.prototype.disableFboIdOrName = function (isFboNameSearch) {
        this.sponsorNotFound = false;
        this.isSponsorEligible = true;
        this.searchBySponsorError = false;
        this.searchByIDOrNameSponsors = null;
        this.selectedSponsor = null;
        if (this.referringFboId && !isFboNameSearch) {
            this.firstName = '';
            this.lastName = '';
            this.isFboNameEnabled = true;
            this.isFboIdEnabled = false;
        }
        else if (this.firstName || this.lastName) {
            this.referringFboId = '';
            this.isFboNameEnabled = false;
            this.isFboIdEnabled = true;
            if (this.firstName) {
                this.firstName = this.firstName.trim();
                this.isFirstNameError = false;
            }
            if (this.lastName) {
                this.lastName = this.lastName.trim();
                this.isLastNameError = false;
            }
        }
        else {
            this.isFboNameEnabled = false;
            this.isFboIdEnabled = false;
        }
    };
    /**
     * searchSponsorByName method used to prepare request for Search by Name
     * @param  {string} firstName
     * @param  {string} lastName
     * @param  {string} countryName
     * @returns void
     */
    SponsorSearchComponent.prototype.searchSponsorByName = function (firstName, lastName, countryId, stateId) {
        if (!this.isSponsorLoading) {
            if (this.referringFboId) {
                this.searchSponsorWizardByFboId();
            }
            else {
                if (!firstName || !lastName) {
                    this.searchBySponsorError = true;
                    this.validateSearchByName(firstName, lastName);
                    this.searchByIDOrNameSponsors = null;
                    this.sponsorNotFound = false;
                    this.noSponsorFound = false;
                    this.selectedSponsorInfo.emit(null);
                }
                else {
                    this.searchBySponsorError = false;
                    this.sponsorNotFound = false;
                    var country = this.countries.find(function (x) {
                        return (x.countryId) === +countryId;
                    });
                    this.sponsorErrorMessage = '';
                    if (firstName.trim() === '' && lastName.trim() === '') {
                        this.noSponsorFound = true;
                        return;
                    }
                    var sponsorSearchRequest = {
                        UserName: '',
                        Email: '',
                        FirstName: firstName ? firstName.trim() : '',
                        LastName: lastName ? lastName.trim() : '',
                        CountryId: country ? country.countryId.toString() : '',
                        PreferenceValue: '',
                        PostalCode: '',
                        StateId: stateId && stateId > 0 ? stateId.toString() : '',
                        City: '',
                        Option: SponsorSearchOption.SearchByFBOName,
                        EnableLongPoll: environment.enableLongPoll,
                        Store: ''
                    };
                    this.getSponsorInformation(sponsorSearchRequest, SponsorSearchOption.SearchByIKnowSponsor);
                }
            }
        }
    };
    /**
    * searchSponsorWizardByFboId used to prepare request for Search By FBO ID or Email
    * @param  {string} FboId?
    * @returns void
    */
    SponsorSearchComponent.prototype.searchSponsorWizardByFboId = function (fboId, error) {
        if (!error) {
            fboId = fboId ? fboId : this.referringFboId;
            if (!fboId) {
                this.refFboIdErrorMessage = 'Enter Sponsor ID / Email';
                return;
            }
            this.searchBySponsorError = false;
            fboId = fboId.indexOf('@') > -1 ? fboId : fboId.split('-').join('');
            var sponsorSearchRequest = {
                UserName: fboId.indexOf('@') > -1 ? '' : fboId.trim(),
                Email: fboId.indexOf('@') > -1 ? fboId.trim() : '',
                FirstName: '',
                LastName: '',
                CountryId: '',
                PreferenceValue: '',
                PostalCode: '',
                StateId: '',
                City: '',
                Option: SponsorSearchOption.SearchByIKnowSponsor,
                EnableLongPoll: environment.enableLongPoll,
                Store: ''
            };
            if (sponsorSearchRequest && sponsorSearchRequest.UserName && sponsorSearchRequest.UserName.length !== 12) {
                this.sponsorNotFound = true;
                return;
            }
            this.getSponsorInformation(sponsorSearchRequest, SponsorSearchOption.SearchByIKnowSponsor);
        }
    };
    /**
    * focus to sugeest sponsor section
    */
    SponsorSearchComponent.prototype.focusOnSuggestSponsor = function () {
        var suggestSponsorElement = document.getElementById('suggestSponsor');
        if (suggestSponsorElement) {
            suggestSponsorElement.focus();
        }
    };
    /**
    * getSponsorInformation used to fetch sponsors from service
    * @param  sponsorSearchRequest
    * @param  {number} option?
    * @returns void
    */
    SponsorSearchComponent.prototype.getSponsorInformation = function (sponsorSearchRequest, searchOption) {
        var _this = this;
        this.pollStarted = true;
        this.searchOptionChanged = false;
        this.isSponsorLoading = true;
        this.resetValidationMessage();
        this.sponsorPollCount = 0;
        sponsorSearchRequest.Store = this.countryCode;
        this._sponsorService
            .searchSponsors(sponsorSearchRequest, this.selectedOrderType)
            .subscribe(function (sponsorSearchResponse) {
            if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
                _this.processSearchSponsorResponse(sponsorSearchResponse, searchOption);
            }
            else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
                sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                setTimeout(function () {
                    _this.searchSponsorByPolling(sponsorSearchResponse, searchOption);
                }, 2000);
            }
            else {
                _this.searchSponsorErrorResponse();
            }
        }, function (error) {
            _this.searchSponsorErrorResponse();
        });
    };
    /**
     * @description we will load sponsor by pooling mechanism
     * @private
     * @param {SponsorSearchRequest} sponsorSearchRequest
     * @param {number} [searchOption]
     * @memberof SponsorSelectionComponentNew
     */
    SponsorSearchComponent.prototype.searchSponsorByPolling = function (searchResponse, searchOption) {
        var _this = this;
        this._sponsorService
            .getSearchSponsorsByUUID(searchResponse)
            .subscribe(function (sponsorSearchResponse) {
            if (sponsorSearchResponse) {
                if (_this.sponsorPollCount < _this.sponsorMaxPollCount) {
                    _this.sponsorPollCount = _this.sponsorPollCount + 1;
                    if (sponsorSearchResponse.requestStatus === ResponseStatus.COMPLETED) {
                        _this.processSearchSponsorResponse(sponsorSearchResponse, searchOption);
                    }
                    else if (sponsorSearchResponse.requestStatus === ResponseStatus.QUEUED ||
                        sponsorSearchResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                        setTimeout(function () {
                            _this.searchSponsorByPolling(sponsorSearchResponse, searchOption);
                        }, 2000);
                    }
                    else {
                        _this.searchSponsorErrorResponse();
                    }
                }
                else {
                    _this.searchSponsorErrorResponse();
                }
            }
        }, function (error) {
            _this.searchSponsorErrorResponse();
        });
    };
    /**
     * @description this method will load when we got error in
     * sponsor search response
     * @private
     * @memberof SponsorSelectionComponentNew
     */
    SponsorSearchComponent.prototype.searchSponsorErrorResponse = function () {
        this.isSponsorLoading = false;
        if (this.isRepSiteSponsor) {
            this.referrerSponsorNotFound = true;
        }
        else if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByIKnowSponsor && !this.searchOptionChanged) {
            this.sponsorNotFound = true;
            this.searchByIDOrNameSponsors = null;
            if (!this.referringFboId) {
                this.noSponsorFound = true;
            }
        }
        else if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByIDontHaveSponsor && !this.searchOptionChanged) {
            this.noSuggestSponsorFound = true;
            this.searchBySuggestSponsors = null;
        }
    };
    /**
    * @description this method will process the search sponsor response
    * @private
    * @param {SponsorSearchResponse} sponsorSearchResponse
    * @param {number} [searchOption]
    * @returns {void}
    * @memberof SponsorSelectionComponentNew
    */
    SponsorSearchComponent.prototype.processSearchSponsorResponse = function (sponsorSearchResponse, searchOption) {
        this.isSponsorLoading = false;
        if (sponsorSearchResponse.sponsorSearchResultModels
            && sponsorSearchResponse.sponsorSearchResultModels.length > 0) {
            sponsorSearchResponse.sponsorSearchResultModels =
                sponsorSearchResponse.sponsorSearchResultModels.map(function (sponsorModel) {
                    sponsorModel.uuid = sponsorSearchResponse.uuid;
                    return sponsorModel;
                });
            if (!this.isRepSiteSponsor) {
                var sponsorResponse = sponsorSearchResponse.sponsorSearchResultModels;
                if (sponsorResponse.length === 1 && sponsorResponse.length > sponsorSearchResponse.sponsorSearchResultModels.length) {
                    this.isSponsorEligible = false;
                    this.noSponsorFound = false;
                    this.referrerSponsorNotFound = false;
                    if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByIDontHaveSponsor) {
                        this.searchBySuggestSponsors = null;
                    }
                    else {
                        this.searchByIDOrNameSponsors = null;
                    }
                }
                else {
                    this.preSelectSponsorBasedOnOption(sponsorSearchResponse, searchOption, true);
                }
            }
            else if (!(sponsorSearchResponse.sponsorSearchResultModels
                && sponsorSearchResponse.sponsorSearchResultModels.length > 0)) {
                this.isReferrerEligible = false;
                this.referrerSponsorNotFound = false;
            }
            else {
                this.isReferrerEligible = true;
                this.referrerSponsorNotFound = false;
                this.prepareMemberMetadataModels(SponsorSearchOption.SearchByIKnowSponsor);
                this.setSponsor(sponsorSearchResponse.sponsorSearchResultModels[0]);
            }
        }
    };
    /**
     * @description
     * @param {SponsorInformation} sponsor
     * @param {number} [index]
     * @memberof SponsorSelectionComponentNew
     */
    SponsorSearchComponent.prototype.setSponsor = function (sponsor, index) {
        sponsor.address = this._sponsorService.mapAddressModel(sponsor);
        this.sponsorInfoNotSelectedErr = false;
        this.selectedSponsor = sponsor;
        this.setSelectedSponsorInformation();
        this.setSponsorInformation();
    };
    /**
     * assignSponsor method used to set sponsors based on selected option
     * @param response
     * @param  {number} option?
     * @returns void
     */
    SponsorSearchComponent.prototype.preSelectSponsorBasedOnOption = function (sponsorSearchResponse, option, isSearch) {
        if (sponsorSearchResponse && sponsorSearchResponse.sponsorSearchResultModels && sponsorSearchResponse.isSuccess) {
            switch (this.sponsorWizard) {
                case this.sponsorSearchWizardType.SearchByIKnowSponsor:
                    this.searchByIKnowSponsor(sponsorSearchResponse);
                    break;
                case this.sponsorSearchWizardType.SearchByIDontHaveSponsor:
                    this.searchByIDontHaveSponsor(sponsorSearchResponse);
                    break;
                default:
                    break;
            }
            if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByIDontHaveSponsor) {
                this.suggestSponsorFound = true;
            }
            if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByFBOName) {
                if (this.searchByIDOrNameSponsors && this.searchByIDOrNameSponsors.length > 0) {
                    this.noSponsorFound = false;
                }
                else {
                    this.noSponsorFound = true;
                }
            }
        }
        else if (this.sponsorWizard ===
            this.sponsorSearchWizardType.SearchByFBOName
            && sponsorSearchResponse && !sponsorSearchResponse.isSuccess) {
            this.noSponsorFound = true;
            this.sponsorErrorMessage = sponsorSearchResponse.responseMessage;
        }
        else if (this.sponsorWizard ===
            this.sponsorSearchWizardType.SearchByIKnowSponsor
            && sponsorSearchResponse && !sponsorSearchResponse.isSuccess) {
            this.sponsorNotFound = true;
            this.sponsorErrorMessage = sponsorSearchResponse.responseMessage;
        }
        else if (this.sponsorWizard === this.sponsorSearchWizardType.SearchByIDontHaveSponsor) {
            this.noSuggestSponsorFound = true;
            this.searchBySuggestSponsors = null;
        }
        if (!sponsorSearchResponse.sponsorSearchResultModels) {
            this.noSponsorFound = true;
        }
    };
    /**
      * @description this method will excecute when the switch case
      * value is searchByIKnowSponsor
      * @private
      * @param {SponsorSearchResponse} sponsorSearchResponse
      * @returns {void}
      * @memberof SponsorSelectionComponentNew
      */
    SponsorSearchComponent.prototype.searchByIKnowSponsor = function (sponsorSearchResponse) {
        var _this = this;
        this.prepareMemberMetadataModels(SponsorSearchOption.SearchByIKnowSponsor);
        if (sponsorSearchResponse.sponsorSearchResultModels.length < 1) {
            this.isSponsorEligible = false;
            this.noSponsorFound = true;
            return;
        }
        else {
            this.isSponsorEligible = true;
            this.noSponsorFound = false;
            this.searchByIDOrNameSponsors = sponsorSearchResponse.sponsorSearchResultModels;
            if (sponsorSearchResponse.sponsorSearchResultModels.length === 1) {
                var sponsorMapModel = this.searchByIDOrNameSponsors[0];
                sponsorMapModel.address = this._sponsorService.mapAddressModel(sponsorMapModel);
                this.selectedSponsor = sponsorMapModel;
                this.searchByIDOrNameSponsors[0]['isAutoSelect'] = true;
                this.setSelectedSponsorInformation();
                this.setSponsorInformation();
            }
            else {
                this.setSelectedSponsorInformation();
                if (this.selectedSponsor) {
                    this.searchByIDOrNameSponsors.forEach(function (sponsor) {
                        if (_this.selectedSponsor.sponsorId === sponsor.sponsorId) {
                            sponsor['isAutoSelect'] = true;
                        }
                    });
                }
            }
        }
    };
    /** set selected sponsor from search suggestion to enrollement process
      */
    SponsorSearchComponent.prototype.setSponsorInformation = function () {
        if (!this.selectedSponsor) {
            this.isSponsorSelected = false;
            this.sponsorNotFound = false;
            this.searchBySponsorError = false;
            this.noSponsorFound = false;
            this.cityOrZipcodeerrMsg = false;
            this.cityFieldRequired = false;
        }
        else {
            this.isSponsorSelected = true;
            this.showAuthorizedFBO = true;
            this.selectedSponsor.memberMetadataModels = this.memberMetadataModels;
            this.selectedSponsor.memberCommunicationPreferences = this.memberCommunicationPreferences;
            this.selectedSponsor.sponsorAssignedOptionId = this.sponsorAssignedOptionId;
            this.selectedSponsor.notifyMeAboutUpdates = this.notifyMeCheckBoxControl.value;
            this.selectedSponsorInfo.emit(this.selectedSponsor);
        }
    };
    /**
    * set selected sponsor information
    * @memberof SponsorSelectionComponentNew
    */
    SponsorSearchComponent.prototype.setSelectedSponsorInformation = function () {
        var sponsorWizard = this.selectedSponsor ? this.sponsorWizard : '';
        var rebindSponsor = {
            sponsorWizardType: sponsorWizard,
            sponsorId: this.referringFboId,
            firstName: this.firstName ? this.firstName : '',
            lastName: this.lastName ? this.lastName : '',
            state: this.selectedSponsorState ? this.selectedSponsorState : 0,
            country: this.selectedSponsorCountry ? this.selectedSponsorCountry : '',
            city: '',
            zipCode: this.suggestSponsorForm ? this.
                suggestSponsorForm.controls['sponsorZipcode'].value : '',
            language: this.suggestSponsorForm ? this.
                suggestSponsorForm.controls['sponsorLanguage'].value : '',
            isDefaultSponsorSelected: this.isLoggedInSponsorInfo,
            selectedSponsor: this.selectedSponsor,
            selectedWizard: this.sponsorWizard
        };
        this.rebindSponsor.emit(rebindSponsor);
    };
    /**
     * @description this method will prepare member
     * metamodels
     * @param {number} option
     * @memberof SponsorSelectionComponentNew
     */
    SponsorSearchComponent.prototype.prepareMemberMetadataModels = function (option) {
        if (!this.isAutoAssign && this.sponsorSearchOptions) {
            var filteredSponsorOption = this.
                sponsorSearchOptions.filter(function (x) { return x.id === option; })[0];
            var nameValues = {
                id: filteredSponsorOption.id,
                option: filteredSponsorOption.option,
                sponsorSearchValues: filteredSponsorOption.sponsorSearchValues,
            };
            this.sponsorAssignedOptionId = filteredSponsorOption.id;
            this.memberMetadataModels = [{
                    code: 'SponsorSearch',
                    name: JSON.stringify(nameValues),
                    memberId: null,
                    keyValueDesc: ''
                }];
        }
    };
    /**
     * @description this method will excecute when the switch case
     * value is searchByIDontHaveSponsor
     * @private
     * @memberof SponsorSelectionComponentNew
     */
    SponsorSearchComponent.prototype.searchByIDontHaveSponsor = function (sponsorSearchResponse) {
        this.prepareMemberMetadataModels(SponsorSearchOption.SearchByIDontHaveSponsor);
        this.noSuggestSponsorFound = false;
        this.suggestSponsorFound = true;
        this.searchBySuggestSponsors = sponsorSearchResponse.sponsorSearchResultModels;
        if (this.searchBySuggestSponsors.length >= 1) {
            var sponsorMapModel = this.searchBySuggestSponsors[0];
            sponsorMapModel.address = this._sponsorService.mapAddressModel(sponsorMapModel);
            this.selectedSponsor = sponsorMapModel;
            this.searchBySuggestSponsors[0]['isAutoSelect'] = true;
            this.setSelectedSponsorInformation();
            this.setSponsorInformation();
        }
        else {
            this.setSelectedSponsorInformation();
        }
    };
    /**
      * @description
      * @param {string} firstName
      * @param {string} lastName
      * @memberof SponsorSelectionComponentNew
      */
    SponsorSearchComponent.prototype.validateSearchByName = function (firstName, lastName) {
        if (!firstName && lastName) {
            this.isFirstNameError = true;
            this.searchBySponsorError = false;
            this.isLastNameError = false;
        }
        else if (firstName && !lastName) {
            this.isFirstNameError = false;
            this.searchBySponsorError = false;
            this.isLastNameError = true;
        }
    };
    /**
     *  Resetting validation message while searching sponsor info
     *  resetValidationMessage
     * @memberof SponsorSelectionComponentNew
     */
    SponsorSearchComponent.prototype.resetValidationMessage = function () {
        this.sponsorNotFound = false;
        this.searchBySponsorError = false;
        this.noSponsorFound = false;
        this.isSponsorSelected = true;
        this.cityOrZipcodeerrMsg = false;
        this.cityFieldRequired = false;
        this.selectedSponsor = null;
        this.sponsorInfoNotSelectedErr = false;
        this.deSelectSponsor();
    };
    /**
    * @description UnselectSponsor method used to unselect the sponsor
    * @returns void
    */
    SponsorSearchComponent.prototype.deSelectSponsor = function () {
        this.selectedSponsor = null;
        this.showAuthorizedFBO = false;
        this.selectedSponsorInfo.emit(this.selectedSponsor);
    };
    /**
       * @description method to get countries lookup
       * @memberof AddressNewComponent
       */
    SponsorSearchComponent.prototype.getCountriesLookup = function () {
        var _this = this;
        if (this._cacheService.get(CacheKey.COUNTRIES)) {
            this.countries = this._cacheService.get(CacheKey.COUNTRIES);
            this.getFilteredCountries(this.countries);
        }
        else {
            this._customerService.getCountriesLookup().subscribe(function (res) {
                if (res && res.length > 0) {
                    _this.countries = res;
                    _this._cacheService.set(CacheKey.COUNTRIES, _this.countries);
                    _this.getFilteredCountries(_this.countries);
                }
            });
        }
    };
    SponsorSearchComponent.prototype.getFilteredCountries = function (countries) {
        var _this = this;
        this.filteredTitanCountries = countries.filter(function (x) { return x.titanPlatformEnabled === true; });
        this.filteredNonTitanCountries = countries.filter(function (x) { return x.titanPlatformEnabled === false; });
        this.browserCountry = countries.find(function (x) {
            return (x.isocodeThree).toLowerCase() === _this.countryCode.toLowerCase();
        });
        if (this.participatingCountry) {
            this.selectedSponsorCountry = this.participatingCountry.countryId;
        }
        else {
            this.selectedSponsorCountry = this.storeInfo && this.storeInfo.countryId ? this.storeInfo.countryId : this.browserCountry.countryId;
        }
        this.countryId = this.selectedSponsorCountry;
        var country = countries.find(function (x) {
            return (x.countryId) === +_this.selectedSponsorCountry;
        });
        if (country) {
            this.selectedCountryISO = country.isocodeThree;
            // Get states By Country
            this.getStatesLookup(country.countryId, true);
        }
    };
    /**
       * @description get states by country
       * @memberof AddressNewComponent
       */
    SponsorSearchComponent.prototype.getStatesByCountryId = function () {
        var _this = this;
        if (this.participatingCountry && this.participatingCountry.countryId) {
            this.selectedSponsorCountry = this.participatingCountry.countryId;
        }
        else {
            this.selectedSponsorCountry = this.storeInfo && this.storeInfo.countryId ? this.storeInfo.countryId
                : this.browserCountry.countryId;
        }
        var country = this.countries
            .find(function (x) { return x.countryId === +_this.selectedSponsorCountry; });
        var hideSponsorStateDropdownCountry = this.sponsorConfig && country && this.sponsorConfig.hideSponsorStateDropdownCountires
            .find(function (x) { return x.toLowerCase() === country.isocodeThree.toLowerCase(); });
        if (country && !hideSponsorStateDropdownCountry && (this.storeInfo.homeIsocodeThree === country.isocodeThree || (this.storeInfo.homeIsocodeThree !== country.isocodeThree && this.sponsorConfig && this.sponsorConfig.isSponsorSearchByArea))) {
            this.countryId = country.countryId;
            this._customerService.getStatesByCountryId(this.countryId).subscribe(function (res) {
                _this.states = res;
                _this.setDefaultStateId(_this.states);
            });
            this.showStates = true;
        }
        else {
            this.showStates = false;
        }
    };
    /**
     * @description On Country change
     * @param {number} event
     * @memberof SponsorSelectionComponentNew
     */
    SponsorSearchComponent.prototype.onCountryChange = function (event) {
        if (event) {
            var countryId = event;
            this.selectedSponsorState = 0;
            this.getStatesLookup(countryId, false);
        }
    };
    /**
    * trim text elment text
    * @param  {FormGroup} form
    * @returns void
    */
    SponsorSearchComponent.prototype.trimValue = function (event) {
        var value = event.target.value;
        if (value) {
            event.target.value = value.trim().length === 0 ? value.trim() : value;
        }
    };
    /**
    *  Getting States By country
    *  getStatesLookup
    * @param {number} countryId
    * @memberof SponsorSelectionComponentNew
    */
    SponsorSearchComponent.prototype.getStatesLookup = function (countryId, reloadSponsorConfig) {
        var _this = this;
        var country = this.filteredTitanCountries && this.filteredTitanCountries.find(function (x) {
            return (x.countryId) === +countryId;
        });
        var hideSponsorStateDropdownCountry = this.sponsorConfig && country && this.sponsorConfig.hideSponsorStateDropdownCountires
            .find(function (x) { return x.toLowerCase() === country.isocodeThree.toLowerCase(); });
        if (country && !hideSponsorStateDropdownCountry) {
            this._customerService.getStoreInfoFromConfig(country.isocodeThree).subscribe(function (res) {
                var storeInfo = res;
                storeInfo.storeCountryCode = country.isocodeThree;
                if (storeInfo.storeCountryCode === storeInfo.homeIsocodeThree || (storeInfo.storeCountryCode !== storeInfo.homeIsocodeThree && _this.sponsorConfig && _this.sponsorConfig.isSponsorSearchByArea)) {
                    _this._customerService.getStatesByCountryId(countryId).subscribe(function (states) {
                        _this.states = states;
                        if (reloadSponsorConfig) {
                            _this.selectedSponsorState = 0;
                        }
                        _this.setDefaultStateId(states);
                    });
                    _this.showStates = true;
                }
                else {
                    _this.showStates = false;
                }
                if (reloadSponsorConfig) {
                    _this.loadSponsorConfigInfo(storeInfo);
                }
            });
        }
        else {
            this.showStates = false;
            if (reloadSponsorConfig) {
                this.loadSponsorConfigInfo();
                this.selectedSponsorState = 0;
            }
        }
    };
    SponsorSearchComponent.prototype.isSponsorInfoSelected = function () {
        var _this = this;
        this._enrollmentMessageService.getIsSponsorInfoSelected().subscribe(function (response) {
            if (!response) {
                _this.sponsorInfoNotSelectedErr = true;
            }
            else {
                _this.sponsorInfoNotSelectedErr = false;
            }
        });
    };
    SponsorSearchComponent.prototype.participatingCountrySelected = function () {
        var _this = this;
        this.participatingCountrySubscription = this._enrollmentMessageService.getParticipatingCountryInfo().subscribe(function (countryID) {
            if (countryID) {
                _this.selectedSponsorCountry = countryID;
                _this.onCountryChange(_this.selectedSponsorCountry);
            }
        });
    };
    /**
     * @description to set the Defaut State ID
     * @author Akhil
     * @date 2021-08-05
     * @param {State[]} states
     * @memberof SponsorSearchComponent
     */
    SponsorSearchComponent.prototype.setDefaultStateId = function (states) {
        if (states && states.length === 1) {
            this.defaultStateId = states[0].id;
            this.selectedSponsorState = this.defaultStateId;
        }
    };
    SponsorSearchComponent.prototype.ngOnDestroy = function () {
        if (this.participatingCountrySubscription) {
            this.participatingCountrySubscription.unsubscribe();
        }
        if (this.storeSubscription) {
            this.storeSubscription.unsubscribe();
        }
    };
    return SponsorSearchComponent;
}());
export { SponsorSearchComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/enrollment/sponsor-search.component.ts.pre-build-optimizer.js